import { useCountdownAnuncio } from "../services/UseCountdownAnuncio";
import { AnunciosShopkeeper } from "../dto/ShopkeeperDTO";
import { Stack, Typography } from "@mui/material";
import { colorNegative } from "../../../theme";
import { ClockFading } from "lucide-react";

interface CronometroRegressivoProps {
  anuncio: AnunciosShopkeeper;
}

export function CronometroRegressivo({ anuncio }: CronometroRegressivoProps) {
  const countdown = useCountdownAnuncio(anuncio);

  if (countdown.expired) {
    return (
      <Typography color="error" fontWeight={700} align="center"mb={2}>
        Encerrado
      </Typography>
    );
  }

  return (
    <Stack alignItems="center">
     
      <Typography
        fontSize="0.75rem"
        fontWeight={700}
        color="text.secondary"
        mb={0.5}
        align="center"
      >
        {anuncio.tipo_anuncio === "L"
          ? "Leilão encerra em"
          : "Anúncio encerra em"}
      </Typography>
      <Stack alignItems={"center"} direction={"row"} spacing={0.5} mb={2}>
        <ClockFading color={colorNegative} size={22}/>
        <Typography fontWeight={900} color={colorNegative}>
        {countdown.days > 0 && `${countdown.days}d `}
        {String(countdown.hours).padStart(2, "0")}:
        {String(countdown.minutes).padStart(2, "0")}:
        {String(countdown.seconds).padStart(2, "0")}
      </Typography>
      </Stack>
    </Stack>
  );
}
